import script from "./SpeakersList.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeakersList.vue?vue&type=script&setup=true&lang=js"

import "./SpeakersList.vue?vue&type=style&index=0&id=f1c739c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1c739c0"]])

export default __exports__